import { Alert } from 'react-native'
import * as RelationshipTypes from '../../../../../constants/relationship_types/RelationshipTypes'
import ApiFetchHandler from '../../../../../api/ApiFetchHandler'
import { i18n } from '$localization/config.js'
import { showDefaultAlert } from '../../../../../navigation/_utils/NavigationUtils'

export const requestAddRelative = async (
  familyMember,
  authCredentials,
  saveError,
  setSectionListRefreshing
) => {
  const { accessToken } = authCredentials
  const payload = familyMember

  if (!payload?.member_id) return

  const relationshipToProband = payload?.relationship_to_proband

  switch (relationshipToProband) {
    case RelationshipTypes.PARTNER: {
      const addPartnerPayload = {
        path: 'member/add_partner/',
        method: 'post',
        token: accessToken,
        body: { ...payload },
        pageDetails: {
          page: 'FamilyMainController.js',
        },
      }

      const addPartnerResponse = await ApiFetchHandler(addPartnerPayload)

      if (addPartnerResponse.isError) {
        setSectionListRefreshing(false)
        saveError({
          isShown: true,
          status: addPartnerResponse.status,
          message: addPartnerResponse.message,
        })
        return
      }

      return {
        ...addPartnerResponse,
        relationshipType: RelationshipTypes.PARTNER,
      }
    }

    case RelationshipTypes.SON:
    case RelationshipTypes.DAUGHTER: {
      const addChildPayload = {
        path: 'member/add_child/',
        method: 'post',
        token: accessToken,
        body: { ...payload },
        pageDetails: {
          page: 'FamilyMainController.js',
        },
      }

      const addChildResponse = await ApiFetchHandler(addChildPayload)

      if (addChildResponse.isError) {
        setSectionListRefreshing(false)
        saveError({
          isShown: true,
          status: addChildResponse.status,
          message: addChildResponse.message,
        })
        return
      }

      return {
        ...addChildResponse,
        relationshipType: relationshipToProband,
      }
    }

    case RelationshipTypes.PREGNANCY:
      Alert.alert(
        i18n.t('add_pregnancy')?.default,
        i18n.t('coming_soon')?.default,
        [
          {
            text: i18n.t('okay').title,
            style: 'cancel',
            onPress: () => this.setState({ showLoadingView: false }),
          },
        ]
      )
      break

    case RelationshipTypes.BROTHER:
    case RelationshipTypes.SISTER: {
      // API request to add sibling
      const addSiblingPayload = {
        path: 'member/add_sibling/',
        method: 'post',
        token: accessToken,
        body: { ...payload },
        pageDetails: {
          page: 'FamilyMainController.js',
        },
      }

      const addSiblingResponse = await ApiFetchHandler(addSiblingPayload)

      if (addSiblingResponse.isError) {
        setSectionListRefreshing(false)
        saveError({
          isShown: true,
          status: addSiblingResponse.status,
          message: addSiblingResponse.message,
        })
        return
      }

      return {
        ...addSiblingResponse,
        relationshipType: relationshipToProband,
      }
    }

    case RelationshipTypes.PARENT:
    case RelationshipTypes.FATHER:
    case RelationshipTypes.MOTHER: {
      const addParentsPayload = {
        path: 'member/add_parents/',
        method: 'post',
        token: accessToken,
        body: { ...payload },
        pageDetails: {
          page: 'FamilyMainController.js',
        },
      }

      const addParentsResponse = await ApiFetchHandler(addParentsPayload)

      if (addParentsResponse.isError) {
        setSectionListRefreshing(false)
        saveError({
          isShown: true,
          status: addParentsResponse.status,
          message: addParentsResponse.message,
        })
        return
      }

      return {
        ...addParentsResponse,
        relationshipType: relationshipToProband,
      }
    }

    case RelationshipTypes.UNCLE:
    case RelationshipTypes.AUNT: {
      const addAuntUnclePayload = {
        path: 'member/add_aunt_uncle/',
        method: 'post',
        token: accessToken,
        body: { ...payload },
        pageDetails: {
          page: 'FamilyMainController.js',
        },
      }
      const addAuntUncleResponse = await ApiFetchHandler(addAuntUnclePayload)
      if (addAuntUncleResponse.isError) {
        setSectionListRefreshing(false)
        saveError({
          isShown: true,
          status: addAuntUncleResponse.status,
          message: addAuntUncleResponse.message,
        })
        return
      }

      return {
        ...addAuntUncleResponse,
        relationshipType: relationshipToProband,
      }
    }

    default:
      showDefaultAlert(
        'Error 400',
        'requestAddRelative(): Unknown relationship type'
      )
      break
  }
}
